export default __webpack_public_path__ + "static/Affordable-19821024d65ddb59d77201729a7ccada.png";